// ========================================================================================================================
// HOME HERO
// let coHomeHeroHeaderHeight = gsap.getProperty("header", "height");
// ===
gsap.set(".co--home--hero--1--3--3--div", { yPercent: -100 });
// ===
gsap.to(".co--home--hero", {
    opacity: 1,
    duration: 1,
    ease: "power2.inOut",
});
// ===
let coHomeHeroTl = gsap.timeline();
coHomeHeroTl.to(".co--home--hero--1--3--1--seven--svg", {
    duration: 1.5,
    ease: "power2.inOut",
    yPercent: -100,
});
coHomeHeroTl.to(
    ".co--home--hero--1--3--1--thirty--svg",
    {
    duration: 1.5,
    ease: "power2.inOut",
    yPercent: 100,
    },
    "-=1.5"
);
coHomeHeroTl.to(
    ".co--home--hero--1--2",
    {
    duration: 1,
    ease: "power2.inOut",
    xPercent: -100,
    opacity: 1,
    },
    "-=1"
);
coHomeHeroTl.to(
    ".co--home--hero--1--3--1--colon",
    {
    duration: 1,
    ease: "power2.inOut",
    opacity: 1,
    },
    "-=1"
);
coHomeHeroTl.to(
    ".co--home--hero--1--3--2--2--div",
    {
    duration: 1.5,
    ease: "power2.inOut",
    xPercent: 100,
    opacity: 1,
    },
    "-=1"
);
coHomeHeroTl.to(
    ".co--home--hero--1--3--2--1--div",
    {
    duration: 1.5,
    ease: "power2.inOut",
    xPercent: 100,
    opacity: 1,
    },
    "-=1.4"
);
// coHomeHeroTl.to(
//     ".header-wrapper",
//     {
//     duration: 1,
//     ease: "power2.inOut",
//     opacity: 1,
//     },
//     "-=1.4"
// );
coHomeHeroTl.to(
    ".co--home--hero--1--3--3--div",
    {
    duration: 1,
    ease: "power2.inOut",
    opacity: 1,
    yPercent: 0,
    },
    "-=1.4"
);
// =====
gsap.to(".co--home--hero--1--3--2--1", {
    scrollTrigger: {
    trigger: ".co--home--hero--guide",
    start: "bottom bottom",
    end: "bottom top",
    scrub: true,
    },
    yPercent: -5,
});
gsap.to(".co--home--hero--1--3--2--1--img", {
    scrollTrigger: {
    trigger: ".co--home--hero--guide",
    start: "bottom bottom",
    end: "bottom top",
    scrub: true,
    },
    scale: 1.2,
});
gsap.to(".co--home--hero--1--3--2--2", {
    scrollTrigger: {
    trigger: ".co--home--hero--guide",
    start: "bottom bottom",
    end: "bottom top",
    scrub: true,
    },
    yPercent: -10,
});
gsap.to(".co--home--hero--1--3--2--2--img", {
    scrollTrigger: {
    trigger: ".co--home--hero--guide",
    start: "bottom bottom",
    end: "bottom top",
    scrub: true,
    },
    scale: 1.1,
});
// ========================================================================================================================
// HOME SUB-HERO
let coHomeSubHeroTimeAni = gsap.timeline();
coHomeSubHeroTimeAni.fromTo(
    ".co--home--sub-hero--2--2--span",
    {
    xPercent: 100,
    },
    {
    ease: "power2.inOut",
    xPercent: 0,
    duration: 1,
    }
);
coHomeSubHeroTimeAni.fromTo(
    ".co--home--sub-hero--2--2--h2",
    {
    yPercent: -100,
    },
    {
    ease: "power2.inOut",
    yPercent: 0,
    duration: 0.5,
    },
    "-=0.5"
);
// ==========
ScrollTrigger.create({
    trigger: ".co--home--sub-hero--2--2",
    toggleActions: "restart none none reverse",
    start: "top bottom",
    end: "top top",
    // markers: true,
    animation: coHomeSubHeroTimeAni,
});
// ===
// ========================================================================================================================
let coTarget = gsap.utils.toArray(".co--home--sub-hero--1--1--1--h2"); 
let coDurationInOut = 0.6;
let coDurationStay = 1;
let coDurationBuffer = "-=0.3";
  
gsap.set(coTarget, { yPercent: 100 });
let coTimeline = gsap.timeline({repeat: -1});

coTimeline.to(coTarget[0], { yPercent: 0, duration: coDurationInOut });
coTimeline.to(coTarget[0], { yPercent: 0, duration: coDurationStay });
coTimeline.to(coTarget[0], { yPercent: -100, duration: coDurationInOut });

coTimeline.to(coTarget[1], { yPercent: 0, duration: coDurationInOut }, coDurationBuffer);
coTimeline.to(coTarget[1], { yPercent: 0, duration: coDurationStay });
coTimeline.to(coTarget[1], { yPercent: -100, duration: coDurationInOut });

coTimeline.to(coTarget[2], { yPercent: 0, duration: coDurationInOut }, coDurationBuffer);
coTimeline.to(coTarget[2], { yPercent: 0, duration: coDurationStay });
coTimeline.to(coTarget[2], { yPercent: -100, duration: coDurationInOut });

coTimeline.to(coTarget[3], { yPercent: 0, duration: coDurationInOut }, coDurationBuffer);
coTimeline.to(coTarget[3], { yPercent: 0, duration: coDurationStay });
coTimeline.to(coTarget[3], { yPercent: -100, duration: coDurationInOut });

coTimeline.to(coTarget[4], { yPercent: 0, duration: coDurationInOut }, coDurationBuffer);
coTimeline.to(coTarget[4], { yPercent: 0, duration: coDurationStay });
coTimeline.to(coTarget[4], { yPercent: -100, duration: coDurationInOut });

coTimeline.to(coTarget[5], { yPercent: 0, duration: coDurationInOut }, coDurationBuffer);
coTimeline.to(coTarget[5], { yPercent: 0, duration: coDurationStay });
coTimeline.to(coTarget[5], { yPercent: -100, duration: coDurationInOut });

coTimeline.to(coTarget[6], { yPercent: 0, duration: coDurationInOut }, coDurationBuffer);
coTimeline.to(coTarget[6], { yPercent: 0, duration: coDurationStay });
coTimeline.to(coTarget[6], { yPercent: -100, duration: coDurationInOut });

coTimeline.to(coTarget[7], { yPercent: 0, duration: coDurationInOut }, coDurationBuffer);
coTimeline.to(coTarget[7], { yPercent: 0, duration: coDurationStay });
coTimeline.to(coTarget[7], { yPercent: -100, duration: coDurationInOut });

coTimeline.to(coTarget[8], { yPercent: 0, duration: coDurationInOut }, coDurationBuffer);
coTimeline.to(coTarget[8], { yPercent: 0, duration: coDurationStay });
coTimeline.to(coTarget[8], { yPercent: -100, duration: coDurationInOut });

coTimeline.to(coTarget[9], { yPercent: 0, duration: coDurationInOut }, coDurationBuffer);
coTimeline.to(coTarget[9], { yPercent: 0, duration: coDurationStay });
coTimeline.to(coTarget[9], { yPercent: -100, duration: coDurationInOut });

coTimeline.to(coTarget[10], { yPercent: 0, duration: coDurationInOut }, coDurationBuffer);
coTimeline.to(coTarget[10], { yPercent: 0, duration: coDurationStay });
coTimeline.to(coTarget[10], { yPercent: -100, duration: coDurationInOut });
// let coHomeHeroSubHeroHeight = gsap.getProperty(".co--home--sub-hero--1--1--1--h2", "height");
// gsap.set('.co--home--sub-hero--1--1', {height: coHomeHeroSubHeroHeight * 2});
// ========================================================================================================================
// HOME COLLECTION
gsap.set(".collection-products", { opacity: 0 });
gsap.to(".collection-products", {
    scrollTrigger: {
    trigger: ".collection-products",
    start: "25% bottom",
    end: "bottom top",
    toggleActions: "play none none reverse",
    },
    duration: 1,
    opacity: 1,
    ease: "power2.inOut",
});
// ========================================================================================================================
// HOME SLIDER ONE
let coHomeSliderOneCopy = document.querySelectorAll(
    ".co--home--slider-one--copy"
);
gsap.set(coHomeSliderOneCopy, { yPercent: 100 });
gsap.to(coHomeSliderOneCopy, {
    scrollTrigger: {
    trigger: ".co--home--slider-one--1",
    start: "25% bottom",
    end: "bottom top",
    toggleActions: "play none none reverse",
    },
    duration: 1,
    yPercent: 0,
    ease: "power2.inOut",
    stagger: 0.2,
});
// ===
gsap.to(".co--home--collage--1--img", {
    scrollTrigger: {
    trigger: ".co--home--collage-div",
    start: "top bottom",
    end: "bottom top",
    scrub: true,
    },
    top: "-20%",
});
// ===
// let child = document.querySelector(`.box:nth-child(${1})`);
let coHomeSliderOneCells = document.querySelectorAll(
    ".co--home--slider-one--2--1"
);
gsap.set(coHomeSliderOneCells, { opacity: 0, yPercent: 50 });
gsap.to(coHomeSliderOneCells, {
    scrollTrigger: {
    trigger: ".co--home--slider-one--2",
    start: "25% bottom",
    end: "bottom top",
    toggleActions: "play none none reverse",
    },
    duration: 1.5,
    opacity: 1,
    yPercent: 0,
    ease: "power2.inOut",
    stagger: 0.2,
});
// ========================================================================================================================
// AM PM
let coHomeAmPmTimeAni = gsap.timeline();
coHomeAmPmTimeAni.fromTo(
    ".co--home--am-pm--1--1--span",
    {
    xPercent: 100,
    },
    {
    ease: "power2.inOut",
    xPercent: 0,
    duration: 1,
    }
);
coHomeAmPmTimeAni.fromTo(
    ".co--home--am-pm--1--1--1",
    {
    yPercent: -100,
    },
    {
    ease: "power2.inOut",
    yPercent: 0,
    duration: 1,
    },
    "-=0.5"
);
coHomeAmPmTimeAni.fromTo(
    ".co--home--am-pm--1--1--2",
    {
    yPercent: 100,
    },
    {
    ease: "power2.inOut",
    yPercent: 0,
    duration: 1.5,
    },
    "-=1"
);
// ==========
ScrollTrigger.create({
    trigger: ".co--home--am-pm--1--1",
    toggleActions: "restart none none reverse",
    start: "top bottom",
    end: "top top",
    // markers: true,
    animation: coHomeAmPmTimeAni,
});
// ===
gsap.set(".co--home--am-pm--svg", { yPercent: 100 });
gsap.to(".co--home--am-pm--svg", {
    scrollTrigger: {
    trigger: ".co--home--am-pm--2",
    start: "25% bottom",
    end: "bottom top",
    toggleActions: "play none none reverse",
    },
    duration: 1.5,
    yPercent: 0,
    ease: "power2.inOut",
});
// ========================================================================================================================
// COLLAGE
let coHomeHeroCollageMarginOne = gsap.getProperty(
    ".co--home--collage--2--2--1--2",
    "height"
);
let coHomeHeroCollageMarginTwo = gsap.getProperty(
    ".co--home--collage--2--2--2--2",
    "height"
);
gsap.set(".co--home--collage--2--2--1--2", {
    marginBottom: -coHomeHeroCollageMarginOne,
});
gsap.set(".co--home--collage--2--2--2--2", {
    marginBottom: -coHomeHeroCollageMarginTwo,
});
let coHomeHeroCollageGreater = Math.max(
    coHomeHeroCollageMarginOne,
    coHomeHeroCollageMarginTwo
);
gsap.set(".co--home--collage-div", {
    paddingBottom: coHomeHeroCollageGreater,
});
// ===
gsap.set(".co--home--collage", { opacity: 0 });
gsap.to(".co--home--collage", {
    scrollTrigger: {
    trigger: ".co--home--collage",
    start: "25% bottom",
    end: "bottom top",
    toggleActions: "play none none reverse",
    },
    duration: 1,
    opacity: 1,
    ease: "power2.inOut",
});
// =============
gsap.set(".co-home-1-right", { opacity: 0 });
gsap.to(".co-home-1-right", {
    scrollTrigger: {
        trigger: ".co-home-1-right",
        start: "top 90%",
        end: "bottom top"
    },
    opacity: 1,
    duration: 1,
    ease: "Power2.inOut"
});
gsap.to(".co-home-1-left-frame img", {
    scrollTrigger: {
        trigger: ".co-home-1-left",
        start: "top bottom",
        end: "bottom top",
        scrub: true
    },
    top: "-10%"
});
gsap.set(".co-home-1-left", { opacity: 0, x: 20 });
gsap.to(".co-home-1-left", {
    scrollTrigger: {
        trigger: ".co-home-1-left",
        start: "top 90%",
        end: "bottom top"
    },
    opacity: 1,
    duration: 1,
    x: 0,
    ease: "Power2.inOut"
});
gsap.set(".co-home-1-left-frame", { opacity: 0, x: -20, y: 20 });
gsap.to(".co-home-1-left-frame", {
    scrollTrigger: {
        trigger: ".co-home-1-left",
        start: "top 90%",
        end: "bottom top"
    },
    opacity: 1,
    duration: 1,
    x: 0,
    y: 0,
    ease: "Power2.inOut"
});
// ========================================================================================================================
// HOME OUR STORY
let coHomeOurStoryTimeAni = gsap.timeline();
coHomeOurStoryTimeAni.fromTo(
    ".co--home--our-story--1--1--span",
    {
    xPercent: 100,
    },
    {
    ease: "power2.inOut",
    xPercent: 0,
    duration: 1,
    }
);
coHomeOurStoryTimeAni.fromTo(
    ".co--home--our-story--1--1--1",
    {
    yPercent: -100,
    },
    {
    ease: "power2.inOut",
    yPercent: 0,
    duration: 1,
    },
    "-=0.5"
);
coHomeOurStoryTimeAni.fromTo(
    ".co--home--our-story--1--1--2",
    {
    yPercent: 100,
    },
    {
    ease: "power2.inOut",
    yPercent: 0,
    duration: 1.5,
    },
    "-=1"
);
// ==========
ScrollTrigger.create({
    trigger: ".co--home--our-story--1--1",
    toggleActions: "restart none none reverse",
    start: "bottom bottom",
    end: "top top",
    // markers: true,
    animation: coHomeOurStoryTimeAni,
});
// ===
gsap.to(".co--home--our-story--2--1--1--img", {
    scrollTrigger: {
    trigger: ".co--home--our-story",
    start: "top bottom",
    end: "bottom top",
    scrub: true,
    },
    scale: 1.15,
});
gsap.set(".co--home--our-story--2", { opacity: 0 });
gsap.to(".co--home--our-story--2", {
    scrollTrigger: {
    trigger: ".co--home--our-story--2",
    start: "top 90%",
    end: "bottom top"
    },
    opacity: 1
});
// ==========
gsap.set(".co-home-2-ani", { opacity: 0, y: 20 });
gsap.to(".co-home-2-ani", {
    scrollTrigger: {
    trigger: ".co-home-2-content-frame",
    start: "top 80%",
    end: "bottom top"
    },
    opacity: 1,
    y: 0,
    duration: 1,
    ease: "Power2.inOut",
    stagger: 0.15
});
// ==========
gsap.set(".co-home-3", { opacity: 0 });
gsap.to(".co-home-3", {
    scrollTrigger: {
    trigger: ".co-home-3",
    start: "top 90%",
    end: "bottom top"
    },
    opacity: 1
});
gsap.to(".co-home-3-blob-frame", {
    scrollTrigger: {
    trigger: ".co-home-3",
    start: "top bottom",
    end: "bottom top",
    scrub: true
    },
    // rotate: 30,
    y: -40,
    x: 70,
    rotateZ: "10deg"
});
// ===
let coHomeOurStoryTimeAni2 = gsap.timeline();
coHomeOurStoryTimeAni2.fromTo(
    ".co--home--our-story--3--1--span",
    {
    xPercent: 100,
    },
    {
    ease: "power2.inOut",
    xPercent: 0,
    duration: 1,
    }
);
coHomeOurStoryTimeAni2.fromTo(
    ".co--home--our-story--3--1--1",
    {
    yPercent: -100,
    },
    {
    ease: "power2.inOut",
    yPercent: 0,
    duration: 1,
    },
    "-=0.5"
);
coHomeOurStoryTimeAni2.fromTo(
    ".co--home--our-story--3--1--2",
    {
    yPercent: 100,
    },
    {
    ease: "power2.inOut",
    yPercent: 0,
    duration: 1.5,
    },
    "-=1"
);
// ==========
ScrollTrigger.create({
    trigger: ".co--home--our-story--3--1",
    toggleActions: "restart none none reverse",
    start: "bottom bottom",
    end: "top top",
    // markers: true,
    animation: coHomeOurStoryTimeAni2,
});